import { useState } from 'react';
import { DismissButton, LoadingIndicator } from '../../lib/iprs-react-library/src/index.js';
import useAppointmentTypeToggle from './useAppointmentTypeToggle';
import userLoggedInHasRole from '../Util/userLoggedInHasRole';
import Notice from '../Util/Notice';

/**
 * Quick-access overlay, opened from the appointment type icon next to a team
 * group's name in the sidebar, listing every appointment type and letting a
 * Diary Manager toggle it Included/Excluded for just this one group.
 * Shares its include/exclude logic with Settings/AppointmentTypeGroupSettings
 * via useAppointmentTypeToggle.
 */
const TeamGroupAppointmentTypesOverlay = ({ api, groupID, groupTitle, onClose }) => {

    const hasDiaryManagerPerm = userLoggedInHasRole(api, 'Diary Manager');

    const [notice, setNotice] = useState(null); // { text, isError }, cleared by the next action

    const { appointmentTypes, savingAppointmentTypeID, isIncluded, toggleAppointmentType } =
        useAppointmentTypeToggle(api, setNotice);

    return <>
        <div className='settings-overlay-backdrop' onClick={onClose} />
        <section className='settings-overlay'>
            <h3>{groupTitle} Appointment Types</h3>
            <Notice notice={notice} onDismiss={() => setNotice(null)} />
            <ul className='settings-list'>
                {appointmentTypes.map(at => {
                    const included = isIncluded(at, groupID);
                    const saving = savingAppointmentTypeID === at.AppointmentTypeID;
                    return (
                        <li key={at.AppointmentTypeID}>
                            <span className='settings-list__label'>{at.Description}</span>
                            {saving && <LoadingIndicator loading={true} size={16} />}
                            <button type='button'
                                className={'settings-table__toggle ' +
                                    (included ? 'settings-table__toggle--included' : '')}
                                disabled={!hasDiaryManagerPerm || saving}
                                title={hasDiaryManagerPerm
                                    ? `Click to ${included ? 'exclude from' : 'include for'} ${groupTitle}`
                                    : undefined}
                                onClick={() => toggleAppointmentType(at, groupID)} >
                                {included ? 'Included' : 'Excluded'}
                            </button>
                        </li>
                    );
                })}
                {0 === appointmentTypes.length &&
                    <li><span className='settings-list__label'>No appointment types found.</span></li>
                }
            </ul>
            <DismissButton onClick={onClose} />
        </section>
    </>;
};

export default TeamGroupAppointmentTypesOverlay;
